// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"c2fbdfc4","311":"5263e316"}[chunkId] + ".chunk.js";
};